import { render, staticRenderFns } from "./CaItem.vue?vue&type=template&id=aabae116&scoped=true&"
import script from "./CaItem.vue?vue&type=script&lang=js&"
export * from "./CaItem.vue?vue&type=script&lang=js&"
import style0 from "./CaItem.vue?vue&type=style&index=0&id=aabae116&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aabae116",
  null
  
)

export default component.exports